import { type LinkOptions, linkOptions } from "@tanstack/react-router";
import type { SearchHit } from "./search.queries";
import { datasetOf, type SearchTypeName } from "./search-types";

// Where a hit opens (ADR-117): a hit names its entity and never a route, so the app decides. Its page where it has
// one, otherwise the panel next to its list; a SKU opens in the panel of its product, a contact on its organization,
// a reference record in its dataset.

const targets: Record<SearchTypeName, (hit: SearchHit) => LinkOptions> = {
  sales_order: (hit) => linkOptions({ to: "/sales-orders/$salesOrderId", params: { salesOrderId: hit.id } }),
  purchase_order: (hit) =>
    linkOptions({ to: "/purchase-orders/$purchaseOrderId", params: { purchaseOrderId: hit.id } }),
  linesheet: (hit) => linkOptions({ to: "/linesheets/$linesheetId", params: { linesheetId: hit.id } }),
  product: (hit) => linkOptions({ to: "/products", search: { panel: hit.id } }),
  sku: (hit) => linkOptions({ to: "/products", search: { panel: hit.parentId ?? undefined } }),
  organization: (hit) => linkOptions({ to: "/organizations/$organizationId", params: { organizationId: hit.id } }),
  contact: (hit) =>
    linkOptions({
      to: "/organizations/$organizationId",
      params: { organizationId: hit.parentId ?? "" },
      search: { tab: "contacts" },
    }),
  etaf: (hit) => linkOptions({ to: "/etaf/$applicationId", params: { applicationId: hit.id } }),
  manufacturer: (hit) => linkOptions({ to: "/manufacturers", search: { panel: hit.id } }),
  sales_campaign: (hit) =>
    linkOptions({ to: "/sales-campaigns/$salesCampaignId", params: { salesCampaignId: hit.id } }),
  appointment: (hit) => linkOptions({ to: "/appointments", search: { panel: hit.id } }),
  user: (hit) => linkOptions({ to: "/admin/users", search: { panel: hit.id } }),
  role: (hit) => linkOptions({ to: "/admin/roles/$roleId", params: { roleId: hit.id } }),
  reference_record: (hit) =>
    linkOptions({ to: "/admin/reference", search: { dataset: datasetOf(hit.parentId), panel: hit.id } }),
};

export const hitTarget = (hit: SearchHit): LinkOptions => targets[hit.type](hit);
